import React from 'react';
import { gql } from '@apollo/client';
import { Show } from 'react-admin';
import RateSettingsShow from '../shared/rate-settings-show/RateSettingsShow';

const StateLocationTypeRateSettingShow = () => (
  <Show>
    <RateSettingsShow />
  </Show>
);

StateLocationTypeRateSettingShow.query = gql`
  query stateLocationTypeRateSetting($id: Int!) {
    stateLocationTypeRateSetting(id: $id, include_parents: true) {
      id
      active
      created_at
      location_type_id
      location_type {
        id
        label
      }
      settings
      state_location_type_rate_setting
      state_id
      state {
        id
        name
      }
      updated_at
    }
  }
`;

export default StateLocationTypeRateSettingShow;
